import { styled } from "@vw-marketing/us-components";

interface ChevronIconProps {
  hideOptions: boolean;
}

export const StyledLabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledIcon = styled.span<ChevronIconProps>`
  display: flex;
  justify-content: flex-end;
  pointer-events: none;
  .animation svg {
    transition: transform 0.2s ease;
    transform: ${({ hideOptions }) =>
      !hideOptions ? `rotate(180deg)` : `rotate(0deg)`};
  }
`;
